import HttpClient from "libs/utils/HttpClient";
import qs from "qs";

class AllDocumentsService {
  async getAllDocuments(body) {
    try {
      const params = qs.stringify({
        ...(body && body.personalId && { personalId: body.personalId }),
        ...(body && body.draftId && { draftId: body.draftId }),
        ...(body && body.smartserviceId && { smartserviceId: body.smartserviceId }),
        ...(body && body.typeDocSmartFromID && { typeDocSmartFromID: body.typeDocSmartFromID }),
        ...(body && body.isBackend && { isBackend: body.isBackend }),
        ...(body && body.statausID && { statausID: body.statausID }),
      });
      const response = await HttpClient.get(`/api/visaformadmin/smartfrom/list?${params}`);


      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async viewDoc(draftId) {
    try {

      const response = await HttpClient.post(`/api/visaformadmin/smartfrom/view`, { draftId: draftId });
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


  async approveDoc(body) {
    try {

      const response = await HttpClient.post(`/api/visaformadmin/smartfrom/boiapprove`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }



  async forceApprove(body) {
    try {

      const response = await HttpClient.post(`/api/visaformadmin/smartfrom/froce`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }



  async otherApproveDoc(body) {
    try {

      const response = await HttpClient.post(`/api/visaformadmin/smartfrom/otherapprove`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


  async rejectDoc(body) {
    try {
      const response = await HttpClient.post(`/api/visaformadmin/smartfrom/reject`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async undo(body) {
    try {
      const response = await HttpClient.post(`/api/visaformadmin/smartfrom/cancelapprove`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async otherUndo(body) {
    try {
      const response = await HttpClient.post(`/api/visaformadmin/smartfrom/cancelapproveotherdep`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }



  async downloadDocDetail(draftId) {
    try {
      const response = await HttpClient.getBlob(`/api/report/resultsmartfrom?draftId=${draftId}`);
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


  async downloadSummaryReport(draftId) {
    try {
      const response = await HttpClient.getBlob(`/api/report/summarize?draftId=${draftId}`);
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


  async requestDocuments(body) {
    try {
      const response = await HttpClient.post(`/api/visaformadmin/smartfrom/reqdoc/add`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async reassignDoc(body) {
    try {
      const response = await HttpClient.post(`/api/visaformadmin/smartfrom/reassign`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async consultDoc(body) {
    try {
      const response = await HttpClient.post(`/api/visaformadmin/smartfrom/sendmanager`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async superaccessList(body) {
    try {
      const params = qs.stringify({
        ...(body && body.draftId && { draftId: body.draftId }),
        ...(body && body.departmentId && { departmentId: body.departmentId }),
      });
      const response = await HttpClient.get(`/api/visaformadmin/superaccess/list?${params}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


  async superaccessremove(body) {
    try {
      const response = await HttpClient.post(`/api/visaformadmin/superaccess/remove`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


  async docLogs(body) {
    try {
      const params = qs.stringify({
        ...(body && body.draftId && { draftId: body.draftId }),
        ...(body && body.departmentId && { departmentId: body.departmentId }),
      });
      const response = await HttpClient.get(`/api/visaformadmin/logsmartfrom/list?${params}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async translateDoc(body) {
    try {
      const params = qs.stringify({
        ...(body && body.smartId && { smartId: body.smartId }),
        ...(body && body.languageCode && { languageCode: body.languageCode }),
        ...(body && body.translateCode && { translateCode: body.translateCode }),

      });
      const response = await HttpClient.get(`/api/translate/read?${params}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }



  async cancelSmartForm(body) {
    try {
      const response = await HttpClient.post(`/api/visaform/smartfrom/delete`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }



  async downloadTerminate(draftId) {
    try {
      const response = await HttpClient.getBlob(`/api/report/terminate?draftId=${draftId}`);
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


  async staffBOIApprove(body) {
    try {
      const response = await HttpClient.post(`/api/visaformadmin/smartfrom/boistaffapprove`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async boiapproveex(body) {
    try {

      const response = await HttpClient.post(`/api/visaformadmin/smartfrom/boiapproveex`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


  async downloadCooperation(body) {
    try {

      const params = qs.stringify({
        ...(body && body.draftId && { draftId: body.draftId }),
      });

      console.log(body);
      console.log(params);
      const response = await HttpClient.getBlob(`/api/report/cooperation?${params}`);
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }



}

export default new AllDocumentsService();

